export default __webpack_public_path__ + "static/media/paypal.0975642d.svg";